import { Component, Input } from '@angular/core';

import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { UploadedImagesListComponent } from './uploaded-images-list/uploaded-images-list.component';

@Component({
  selector: 'app-upload-images',
  standalone: true,
  imports: [ButtonModule, RippleModule],
  templateUrl: './upload-images.component.html',
  styleUrl: './upload-images.component.scss'
})
export class UploadImagesComponent {
  @Input() hideUploadAction!: boolean;
  @Input() smallAction!: boolean;
  @Input() classess!: string;


}
